/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class TimeRecordingGlobalTextKey {
  static readonly APP_TITLE = 'time-recording/global/appTitle';
}
